const PRINT_ID = 'print-wsj';
const SCALE = 1;

export { PRINT_ID, SCALE };
